/**
 * Configuration des routes par défaut pour chaque type d'activité
 * 
 * Chaque activité peut avoir accès à un sous-ensemble spécifique des routes disponibles.
 * Cette configuration définit les routes par défaut pour chaque type d'activité.
 */

export const defaultActivityRoutes = {
  // Restaurant : accès complet à toutes les fonctionnalités
  restaurant: [
    'dashboard',
    'quick-access',
    'pos',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'tables',
    'users-management',
    'payments',
    'mouvements-caisse',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ],

  // Boulangerie : focus sur la vente
  boulangerie: [
    'dashboard',
    'quick-access',
    'pos',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'payments',
    'mouvements-caisse',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ],

  // Salon de coiffure : gestion des rendez-vous et des services
  coiffure: [
    'dashboard',
    'quick-access',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'appointments',
    'users-management',
    'payments',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ],

  // Auto-école : gestion des cours et des élèves
  autoecole: [
    'dashboard',
    'quick-access',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'appointments',
    'users-management',
    'payments',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ],

  // Magasin de vêtements : gestion complète des stocks et des ventes
  vetements: [
    'dashboard',
    'quick-access',
    'pos',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'approvisionnements',
    'users-management',
    'payments',
    'mouvements-caisse',
    'settings',
    'activity-settings',
    'modeles-vente'
  ],

  // Service de réparation : gestion des services et des clients
  reparation: [
    'dashboard',
    'quick-access',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'appointments',
    'users-management',
    'payments',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ],

  // Accessoires électroniques : gestion des stocks et des ventes
  electronique: [
    'dashboard',
    'quick-access',
    'pos',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'approvisionnements',
    'users-management',
    'payments',
    'mouvements-caisse',
    'settings',
    'activity-settings',
    'modeles-vente'
  ],

  // Épicerie : gestion des stocks et des ventes
  epicerie: [
    'dashboard',
    'quick-access',
    'pos',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'approvisionnements',
    'users-management',
    'payments',
    'mouvements-caisse',
    'settings',
    'activity-settings',
    'modeles-vente'
  ],

  // Atelier (menuisier, aluminium, garagiste) : gestion des devis et commandes
  atelier: [
    'dashboard',
    'quick-access',
    'products',
    'categories',
    'customers',
    'sales',
    'sales/new',
    'sales/:id/edit',
    'commandes',
    'users-management',
    'payments',
    'settings',
    'activity-settings',
    'modeles-vente',
    'approvisionnements'
  ]
};

/**
 * Récupère les routes autorisées pour une activité
 * @param {string} activityId - ID de l'activité
 * @returns {Array} - Liste des routes autorisées
 */
export const getAllowedRoutes = (activityId) => {
  return activityId ? defaultActivityRoutes[activityId] || [] : [];
}; 